var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26 2L9.5 17L2 10.1818","stroke":"#070D0E","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"28","height":"19","viewBox":"0 0 28 19","fill":"none"};

module.exports = Check;

Check.default = Check;
